import { render } from "./rateio.vue?vue&type=template&id=229d746e&scoped=true"
import script from "./rateio.vue?vue&type=script&lang=js"
export * from "./rateio.vue?vue&type=script&lang=js"

import "./rateio.vue?vue&type=style&index=0&id=229d746e&scoped=true&lang=css"

import exportComponent from "/var/www/amee/gdaudit-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229d746e"]])

export default __exports__